<div class="vincent_menu1_block">

    <h2>{{"explore_lists" | translate}}</h2>
    <p style="font-size: 10px;">*{{"menu_note" | translate}}*</p>
    <div class="vincent_container">
        <div class="container cont" id="container">
           <h2 class="choose-h2" id="choose"><mdb-icon far icon="plus-square" class="pd-right"></mdb-icon>{{"please_select" | translate}}</h2>
           <h2 class="choose-h2" *ngIf="please_select_again == true"><mdb-icon fab icon="creative-commons-zero" class="null-ico"></mdb-icon>{{"please_select_again" | translate}}</h2>
               <div class="md-form md-form-cus" id="search_bar" style="display: none;">
                    <input mdbInput type="text" id="input" class="form-control search-input" style="text-transform: uppercase;">
                    <label for="input">
                        <mdb-icon fas icon="search"></mdb-icon>
                        {{"search_keyword" | translate}}
                    </label>
                </div>
                <a href="#" class="arrow down" id="arrow">Down</a>
              <ngb-tabset>
                 <ngb-tab class="tabs vincent_menu_tabs" *ngFor="let data of menu;">
                    <ng-template ngbTabTitle>
                        <div (click)="sub(data.id)" style="margin-bottom: 35px;" *ngIf="title_en == true">{{data.title}}</div>
                        <div (click)="sub(data.id)" style="margin-bottom: 35px;" *ngIf="title_ar == true">{{data.title_ar}}</div>
                    </ng-template>
                    <ng-template ngbTabContent>
                      <div class="row gutters">
                      
                            <div class="col-lg-3 col-md-3 col-sm-12" *ngFor="let info of singlemenu; index as i">
                                <div class="vincent_menu1_block_item">
                                    <div class="vincent_prod_list_image_cont">
                                        <div class="vincent_prod_list_image_wrapper">
                                            <div class="vincent_single_product_gall">
                                                <div class="vincent_single_product_img">
                                                    <a class="swipebox">
                                                        <div class="vincent_team_overlay numb">
                                                            <a class="vincent_single_product_search numb-2" (click)="basicModal.show()">
                                                                <i class="fa fa-search" aria-hidden="true"></i>
                                                            </a>
                                                        </div>
                                                        <img [src]="info.photoUrl" class="circle-img">
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div mdbModal #basicModal="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel" aria-hidden="true">
                                        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                                            <div class="modal-content">
                                                <div class="modal-body" style="text-align:center">
                                                    <h4 class="modal-title" id="myModalLabel">{{"show_img" | translate}}</h4>
                                                    <img [src]="info.photoUrl" class="img-responsive model-img">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <h5 *ngIf="title_en == true" ><a [routerLink]="['/single', data.id, info.id]">{{info.title}}</a></h5>
                                    
                                    <h5 *ngIf="title_ar == true" ><a [routerLink]="['/single', data.id, info.id]">{{info.title_ar}}</a></h5>

                                    <p class="vincent_prod_list_text" *ngIf="description_en == true">{{info.description}}</p>
                                    
                                    <p class="vincent_prod_list_text" *ngIf="description_ar == true">{{info.description_ar}}</p>

                                    <div class="vincent_prod_list_price" style="margin-bottom: 15px;"> {{info.price}} </div>
                                
                                    <div class="vincent_prod_list_price">{{"sar" | translate}}</div>
                                                            
                                    <a class="vincent_button" (click)="addtocart(i)" *ngIf="add !== i" ><i class="fa fa-plus" aria-hidden="true" style="position: relative; right: 9px;"></i> {{"add_to_order" | translate}}</a>
                                 
                                    <div *ngIf="add === i">
                                        <input type="number" value="1" placeholder='{{"done_adding" | translate}}' #amount style="margin-bottom: 20px;" min="0" max="10">
                                        <a class="vincent_button" (click)="buy(amount.value)"><i class="fa fa-plus" aria-hidden="true" style="position: relative; right: 9px;"></i>  {{"add" | translate}}</a>
                                    </div>
                                    <div class="alert alert-primary cus" role="alert" *ngIf="done == true">
                                        {{"done_adding" | translate}}
                                     </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </ngb-tab>
            </ngb-tabset>
            <a class="vincent_button" (click)="showMore()" *ngIf="showMoreBtn == true">{{"show_more" | translate}}</a>
        </div>
    </div>